<div class="container">
    <article class="brand-details">
        <div class="fixed-width">
            <div class="feature">
                <img
                    class="feature-img"
                    alt="2cr meals served"
                    src="{{ DEPLOY_URL }}/assets/images/brand_features/meals.png" /><br />
                <div class="bold pre-wrap">2Cr+&#10;Meals</div>
                <span class="feature-details">served & we are not stopping!</span>
            </div>
            <div class="feature">
                <img class="feature-img" alt="300+ stores" src="{{ DEPLOY_URL }}/assets/images/brand_features/stores.png" /><br />
                <div class="bold pre-wrap">300+&#10;Stores</div>
                <span class="feature-details">In Mumbai, Delhi NCR, Bangalore, Hyderabad, Pune, Chennai & Kolkata</span>
            </div>
            <div class="feature">
                <img
                    class="feature-img"
                    alt="superfast delivery in 28 mins"
                    src="{{ DEPLOY_URL }}/assets/images/brand_features/time.png" /><br />
                <div class="bold">28 Minutes</div>
                <span class="feature-details">Superfast Delivery. We reach you before the hunger does.</span>
            </div>
            <div class="feature">
                <img class="feature-img" alt="4.3 rating" src="{{ DEPLOY_URL }}/assets/images/brand_features/rating.png" /><br />
                <div class="bold">
                    4.3
                    <img class="star" src="{{ DEPLOY_URL }}/assets/images/yellow_star.svg" alt="4.3 star" />
                </div>
                <span class="feature-details">rated & 11000+ 5 star reviews that keep us motivated.</span>
            </div>
        </div>
    </article>
    <article class="order-now">
        <div class="order-now-wrapper">
            <h1 class="brand-color">India’s Largest</h1>
            <h1>Desi Meals Brand</h1>
            @if (!isMobile) {
                <div class="brand-description">
                    Irresistible meals in easy-to-carry boxes. <br />
                    All-in-1 meals, Biryanis, Curries, Parathas, Desserts & more delivered piping hot.
                </div>
            }
            @if (!isMobile && !isRepeatUser) {
                <img src="{{ DEPLOY_URL }}/assets/images/curly_arrow.png" class="curly-arrow" alt="arrow" />
            }
        </div>
    </article>
</div>
@if (!isRepeatUser) {
    <img class="wave" src="{{ DEPLOY_URL }}/assets/images/wave.png" alt="wave" />
}
<br />
